module.exports = __webpack_public_path__ + "media/images/icons/twotone/property-safety-90547666986ea3744d472c75e18001b0.svg";